import useAsyncEffect from 'lib/frontend/hooks/useAsyncEffect';
import { ColumnService } from 'lib/services/directory';
import { AdjudicationAreaWithId } from 'lib/types/adjudicationArea';
import { getFirebaseContext } from 'utils/firebase';

import { SelectAdjudicationAreaDropdown } from './SelectAdjudicationAreaDropdown';

export function SelectAdjudicationStateDropdown({
  selectedState,
  onStateSelected
}: {
  selectedState?: AdjudicationAreaWithId;
  onStateSelected: (selection: AdjudicationAreaWithId) => void;
}) {
  const {
    value: stateOptions,
    isLoading: loadingAreas,
    isError: error
  } = useAsyncEffect({
    fetchData: async () => {
      const statesRef = await getFirebaseContext()
        .adjudicationAreasRef()
        .where('type', '==', 'state')
        .orderBy('name')
        .get();

      return statesRef.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as AdjudicationAreaWithId[];
    },
    dependencies: [],
    errorConfig: {
      message: 'Failed to load adjudication areas in placement flow',
      service: ColumnService.WEB_PLACEMENT
    }
  });

  function onChangeHandler(areaId: string) {
    const objectWithinList = stateOptions?.find(state => state.id === areaId);
    if (!objectWithinList) return;
    onStateSelected(objectWithinList);
  }

  return (
    <SelectAdjudicationAreaDropdown
      selectedState={selectedState}
      areaOptions={stateOptions}
      onChange={onChangeHandler}
      label="State"
      placeholder="Select a state"
      loading={loadingAreas}
      error={error}
    />
  );
}
